import React from "react";
import { ButtonBase, Divider, Paper, Radio, Stack, Typography, useTheme } from "@mui/material";
import { HugeiconsIcon, IconSvgElement } from "@hugeicons/react";

interface Props {
  label: string;
  icon: IconSvgElement;
  isChecked: boolean;
  onChange?: () => void;
  children?: React.ReactNode;
}

const PaymentMethod = ({ label, icon, isChecked, children, onChange }: Props) => {
  const { palette } = useTheme();

  const color = isChecked ? palette.primary.main : "black";

  if (children) {
    return (
      <Paper
        sx={{
          width: "100%",
          borderRadius: 1.5,
          position: "relative",

          ["&::after"]: {
            content: "''",
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            borderRadius: 1.5,
            boxShadow: isChecked ? `0px 0px 0px 3px inset ${palette.primary.main}` : "unset",
            pointerEvents: "none",
          },
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" py={2} pl={1} pr={3}>
          <Stack direction="row" alignItems="center" spacing={2} pl={2}>
            <HugeiconsIcon icon={icon} size={28} strokeWidth={1.5} color={color} />
            <Typography>{label}</Typography>
          </Stack>
        </Stack>
        <Divider />
        {children}
      </Paper>
    );
  }

  return (
    <ButtonBase
      sx={{
        borderRadius: 1.5,
      }}
      onClick={onChange}
    >
      <Paper
        sx={{
          py: 1,
          pl: 1,
          pr: 3,
          width: "100%",
          borderRadius: 1.5,
          position: "relative",

          ["&::after"]: {
            content: "''",
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            borderRadius: 1.5,
            boxShadow: isChecked ? `0px 0px 0px 3px inset ${palette.primary.main}` : "unset",
          },
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={2} pl={2}>
            <HugeiconsIcon icon={icon} size={28} strokeWidth={1.5} color={color} />
            <Typography>{label}</Typography>
          </Stack>
          <Radio size="medium" color={"primary"} checked={isChecked} />
        </Stack>
      </Paper>
    </ButtonBase>
  );
};

export default PaymentMethod;
